import { Display } from '@/components/Display/Display';
import Status from './Status.jsx';
import AddInfo from './AddInfo.jsx';
const MobileIntelligentQA = (props) => {
    console.log(props, 'props');
    const { messageInfo, intelligent_qa_result } = props;
    const { intelligent_qa_status, intelligent_qa_clarification } = intelligent_qa_result;
    let isHasClari = intelligent_qa_clarification && Object.keys(intelligent_qa_clarification).length > 0;
    let selected_value = intelligent_qa_clarification?.selected_value || [];
    const isSubmit = selected_value?.length > 0;

    return (
        <>
            <Display show={!isHasClari}>
                <Status intelligent_qa_status={intelligent_qa_status} messageInfo={messageInfo}></Status>
            </Display>
            <Display show={isHasClari}>
                <AddInfo
                    isSubmit={isSubmit}
                    intelligent_qa_clarification={intelligent_qa_clarification}
                    intelligent_qa_status={intelligent_qa_status}
                    messageInfo={messageInfo}
                ></AddInfo>
            </Display>
        </>
    );
};
export default MobileIntelligentQA;
